module.exports = __webpack_public_path__ + "static/media/close-detail.f2aee9ab.svg";